export function isAmazonMcpAdvertiserEnabled(readiness) {
  return readiness?.enabled === true;
}
